import i18next from "../../../i18n";

i18next.addResourceBundle("en", "ConfigureOrgModal", {
    title: "Configure organization",
    button_action: "Update cms actions",
    button_theme: "Update cms themes",
    button_policy: "Update cms policies",
    actions_update_success: "{{count}} actions created or updated",
    themes_update_success: "{{count}} themes created or updated",
    policies_update_success: "{{count}} policies created or updated",
    tenant_initialization_success:
        "Tenant initialization started. Will take a few minutes.",
    button_init_all: "Initialize tenant",
    select_module: "Select Module",
    select_module_description: "Select the module you want to use",
    is_core_module: "Has client paid for the core module?",
    product_activation: "Products & Add-ons activation",
    core: "Core",
    questionnaire: "Questionnaire",
    supplier: "Supplier",
    frameworks: "Frameworks",
    add_on_modules: "Frameworks",
    add_on_evs: "Ecovadis",
    add_on_csrd: "CSRD",
    add_on_cdp: "CDP",
    save: "Save",
});

i18next.addResourceBundle("fr", "ConfigureOrgModal", {
    title: "Configurer l'organisation",
    button_action: "Mettre à jour les actions avec le CMS",
    button_theme: "Mettre à jour les thèmes avec le CMS",
    button_policy: "Mettre à jour les politiques avec le CMS",
    actions_update_success: "{{count}} actions créées ou mis à jour",
    themes_update_success: "{{count}} thèmes créés ou mis à jour",
    policies_update_success: "{{count}} politiques créées ou mis à jour",
    tenant_initialization_success:
        "L'initialisation du compte est démarée. Elle va prendre quelques minutes.",
    button_init_all: "Initialiser le tenant",
    select_module: "Sélectionner un module",
    select_module_description:
        "Sélectionnez le module que vous souhaitez utiliser",
    is_core_module: "Le client a-t-il payé pour le module principal?",
    product_activation: "Activation des produits et modules complémentaires",
    core: "Core",
    questionnaire: "Questionnaire",
    supplier: "Fournisseur",
    frameworks: "Frameworks",
    add_on_modules: "Référentiels",
    add_on_evs: "Ecovadis",
    add_on_csrd: "CSRD",
    add_on_cdp: "CDP",

    save: "Enregistrer",
});
